<template>
  <div>
    <mdb-card class="card-image image">
      <div class="text-white text-center rgba-stylish-strong py-0 px-4">
        <div class="py-5">
          <h2 class="h2 orange-text"><mdb-icon icon="project-diagram" />ICT Consultancy</h2>
        </div>
      </div>
    </mdb-card>
    <div>
      <mdb-container class="backgroundImg">
        <mdb-row>
          <mdb-col col="sm">
            <h1 class="h2 my-3 text-center">ICT consultancy</h1>
          </mdb-col>
        </mdb-row>
        <div>
          <p>
            Frequently, companies buy technology hoping that it will fit their organization and serve the company’s needs. This approach does not always work in most cases. Hypertech IT Consultants offers ICT Consultancy services to design a guideline for your technology needs and see the strategies put in place realized to achieve results.We consult and advise in the following areas:
            <ul>
              <li>ICT Policy & Strategy documentation</li>
              <li>ICT needs, analysis and audits</li>
              <li>Technological infrastructure planning, Analysis and Evaluation</li>
              <li>ICT Security</li>
            </ul>
          </p>
          <div>
            <img src="@/assets/ict solutions.jpg" alt="" height="250px" width="100%" class="margin">
          </div>
        </div>
      </mdb-container>
    </div>
  </div>
</template>

<script>
import mdbCard from 'mdbvue/lib/components/mdbCard'
import mdbIcon from 'mdbvue/lib/components/mdbIcon'
import mdbContainer from 'mdbvue/lib/components/mdbContainer'
import mdbRow from 'mdbvue/lib/components/mdbRow'
import mdbCol from 'mdbvue/lib/components/mdbCol'

export default {
  name: 'IctConsultancy',
  components: {
    mdbCard,
    mdbIcon,
    mdbContainer,
    mdbRow,
    mdbCol
  }
}
</script>

<style scoped>
.image {
  background: url("~@/assets/ICTConsultancy.jpeg");
}
</style>
